/**
 * @class ErrorEnCargaDelCallejero
 * @namespace usig
 * @constructor
 */
function ErrorEnCargaDelCallejero (){

    this.message = "El callejero no se encuentra cargado aún o se produjo un error al intentar cargarlo";
    /**
     * Devuelve un mensaje de error
     * @return {String} Mensaje de error
     */
    this.toString = function() {
        return "Callejero no disponible.";
    };

    /**
     * Devuelve un mensaje de error más descriptivo y amigable
     * @return {String} Mensaje de error
     */
    this.getErrorMessage = function() {
        return this.message;
    }
}
export default ErrorEnCargaDelCallejero;


// WEBPACK FOOTER //
// ./src/ErrorSinDatos.js